import { Component, EventEmitter, OnInit, Output, ViewChild, Input } from '@angular/core';
import { ToolRequest } from '@models/toolRequests.model';
import { ConfirmationModalComponent, ModalComponent } from '@app/shared/components';
import { ToolRequestsService } from '@services/tool-requests.service';
import { Log } from 'ng2-logger';
import { ToolRequestStatus } from "@app/tool/model/enums/tool-request-status.enum";
import { PermissionService } from "@app/authentication/services/permission.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-pending-tool-requests-modal',
    templateUrl: './pending-tool-requests-modal.component.html',
    styleUrls: ['./pending-tool-requests-modal.component.scss']
})
export class PendingToolRequestsModalComponent implements OnInit {
    _logger = Log.create(PendingToolRequestsModalComponent.name);

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
    @ViewChild(ConfirmationModalComponent, {static: true}) confirmationModal: ConfirmationModalComponent;

    @Output()
    closeToolRequest: EventEmitter<any> = new EventEmitter();

    @Input() label: string;
    @Input() isConfirmationInProgress;

    loading = true;

    public pendingToolRequest = new ToolRequest();

    constructor(private permissionService: PermissionService,
                private toolRequestsService: ToolRequestsService,
                private translate: TranslateService) {
    }

    ngOnInit() {
    }

    open(pendingToolRequest = new ToolRequest()) {
        this.loading = true;
        this.pendingToolRequest = pendingToolRequest;
        this.modal.open();
        this.getToolsForToolRequest(this.pendingToolRequest.id)
    }

    close() {
        this.modal.close();
    }

    closeConfirmationModal() {
        this.confirmationModal.close();
    }

    getToolsForToolRequest(id: number) {
        this._logger.info('getToolsForToolRequest:: Retrieving Tools for tool request id', id);
        this.toolRequestsService.getToolRequestTools(id).subscribe(
            (data) => {
                this._logger.info('getToolsForToolRequest:: API returned data', data);
                this.pendingToolRequest.requestTools = data.items;
                this.loading = false;
            }, (error) => {
                this._logger.info('getToolsForToolRequest:: API returned error', error);
                this.loading = false;
            }
        );
    }

    computeCanRenderClose(toolRequest: ToolRequest) {
        return toolRequest.status === ToolRequestStatus.NEW && this.shouldRenderModifiers();
    }

    clickCloseToolRequest() {
        this.modal.close();
        this.confirmationModal.open();
    }

    onConfirmOrder(reason) {
        this.pendingToolRequest.closeReason = reason;
        this.closeToolRequest.emit(this.pendingToolRequest);
    }

    shouldRenderModifiers() {
        return this.permissionService.hasHasPermissionForFeature('CREATE_TOOL_REQUESTS');
    }

    getCloseReason() {
         if (this.pendingToolRequest.closeReason) {
             const closeReason = this.translate.instant(this.pendingToolRequest.closeReason);
             return closeReason ? closeReason : this.pendingToolRequest.closeReason;
         }
    }

    shouldShowClosedInfo() {
        return this.pendingToolRequest.status === 'Canceled' ||  this.pendingToolRequest.status === 'Closed';
    }
}
